export default __webpack_public_path__ + "static/media/officeaddress.9dcbf44a.png";